import React from 'react'

export default function WeddingMoment() {
  return (
    <>
      <section className="wedding-moment-area">
        <div className="wedding-moment-banner">
          <img src="/image/wedding-moment.webp" alt="moments" className="img-responsive" />
          <span className='heading'>Perfect Moments</span>
        </div>

        <div className="wedding-celebration-wrap">
          <img src="/image/wedding-celebration-1.webp" alt="celebration" className="img-responsive" />
          <div className="container">
            <div className="row justify-content-end">
              <div className="col-lg-4 col-md-4">
                <div className="wedding-celebration-content">
                  <img src="/image/wedding-celebration-2.webp" alt="celebration" className="img-responsive" />
                  <label>Wedding Celebration</label>
                  <span>Celebrate your forever at De Coracao Resort, where timeless elegance meets heartfelt celebrations, and from intimate vows to grand festivities, every moment is designed to be beautifully unforgettable with flawless planning and curated experiences.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
